import jsPDF from 'jspdf';
import { format } from 'date-fns';
import 'jspdf-autotable';

  const MaterialIssuePDFGenerator = (generateId, data) => {
;
    
    const pdf = new jsPDF();
    const userData = localStorage.getItem("UserData");
    let parsedUser;
    parsedUser = JSON.parse(userData);
    // Prepare The Font
    const font = "Newsreader";
    const company = data && data.length > 0 && data[0].consumerName
    // header Image
    const headerImage = "../../../image/icons/letter.jpg";
    pdf.addImage(headerImage, 'JPG', 10, 10, 190, 43);

    // prepare in here a line
    pdf.setLineWidth(0.1);
    // Line color (RGB)
    pdf.setDrawColor(200, 200, 200);
    pdf.line(10, 55, 200, 55)


    pdf.setFontSize(10);
    pdf.setFont(`${font}`, 'normal');
    pdf.text('Material Issue Details', 10, 60);
    pdf.text('Invo No: ', 10, 66);
    pdf.text(generateId, 25, 66);
    // pdf.text("Consumer", 10, 72);
    // pdf.text(data && data.length > 0 && data[0].consumerName, 27, 72);
    pdf.text(`Date On: ${format(new Date(), 'MMM dd, yyyy')}`, 166, 60);



    // Description
    pdf.setFontSize(11)
    pdf.setFont(`${font}`, 'bold')
    pdf.text('Dear,', 10, 85)
    pdf.text(`${company}`, 21, 85)
    const description = `We have approved your request. so, your ordered items are listed below:`;
    const longText = description && description !== "" && description?.trim();
    pdf.setFont(`${font}`, 'normal')
    pdf.setFontSize(11)
    const splitText = pdf.splitTextToSize(longText, 185)
    pdf.text(splitText, 10, 92);


    // Set document properties
    pdf.setProperties({
      title: "Material Issue For Quotation"
    })


    // Generate AutoTable for item details
    const itemDetailsRows = data?.map((item, index) => [
      (index + 1).toString(),
      item.productName.toString(), 
        item.OrderQty.toString(), 
        item.UnitName.toString(), 
        `${item.OrderType.replace(/([a-z])([A-Z])/g, '$1 $2').substring(0, 20).toString()}...`, 
       `$${ item.amount.toString()}`, 
        `$${(parseInt(item.OrderQty) * parseInt(item.amount)).toString()}`
     
    ]);
    const itemDetailsHeaders = ['S.No', 'Item Name', 'Quantity', 'Units', 'Issue Type', 'Unit Price', 'Total'];
    const columnWidths = [15, 40,20, 30, 30, 30,25]; 
    // Define table styles
    const headerStyles = {
      fillColor: [240, 240, 240],
      textColor: [0],
      fontFamily: 'Newsreader',
      fontStyle: 'bold',
    };

    pdf.setFont('Newsreader');
    const itemDetailsYStart = 100;
    pdf.autoTable({
      head: [itemDetailsHeaders],
      body: itemDetailsRows,
      startY: itemDetailsYStart, // Adjust the Y position as needed
      headStyles: {
        fillColor: headerStyles.fillColor,
        textColor: headerStyles.textColor,
        fontStyle: headerStyles.fontStyle,
        fontSize: 10, // Adjust the font size as needed
        font: 'Newsreader', // Set the font family
        halign: 'left',
      },
      columnStyles: {
        0: { cellWidth: columnWidths[0] }, // Adjust column widths as needed
        1: { cellWidth: columnWidths[1] },
        2: { cellWidth: columnWidths[2] },
        3: { cellWidth: columnWidths[3] },
        4: { cellWidth: columnWidths[4] },
        5: { cellWidth: columnWidths[5] },
        6: { cellWidth: columnWidths[6] },
      },
      alternateRowStyles: { fillColor: [255, 255, 255] },
      bodyStyles: {
        fontSize: 10, // Adjust the font size for the body
        font: 'Newsreader', // Set the font family for the body
        cellPadding: { top: 1, right: 5, bottom: 1, left: 2 }, // Adjust cell padding
        textColor: [0, 0, 0], // Set text color for the body
        rowPageBreak: 'avoid', // Avoid row page breaks
      },
      margin: { top: 10, left: 10 },
    });


    // Add summary and page numbers
    const summaryYStart = pdf.internal.pageSize.getHeight() - 50;

    pdf.setFont('Newsreader', 'noraml')
    pdf.text('Thanking You,', 13, summaryYStart + 18)
    pdf.text('Yours Faithfully,', 13, summaryYStart + 23)
    pdf.text('For ', 13, summaryYStart + 28)
    pdf.setFont('Newsreader', 'bold')
    pdf.text('The Palms Hotel', 19, summaryYStart + 28)

    const totalPages = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFontSize(10);
      pdf.setFont('Newsreader', 'normal');
      pdf.text(`Page ${i} of ${totalPages}`, pdf.internal.pageSize.width - 10, pdf.internal.pageSize.height - 8, { align: 'right' });
      
      pdf.line(10, 283, 200, 283)
      pdf.setFont(`${font}`, "italic")
      pdf.text(`Prepared By:${parsedUser?.name}`, 10, pdf.internal.pageSize.height - 8)
    }
    // pdf.line(10, 283, 200, 283)
    // pdf.setTextColor(...ColorConverter('#099396'))
    // pdf.setFont(`${font}`, "italic")
    // pdf.text(`Prepared By:${parsedUser?.name}`, 10, 290)

    return  pdf.save('MaterialIssue.pdf');

  }

export default MaterialIssuePDFGenerator;
























